module.exports = __webpack_public_path__ + "static/img/time-weekly.76c3642.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/time-weekly.png
// module id = 4AC6
// module chunks = 1